import React from "react";

export default function StationeryTab() {
  return <div>StationeryTab</div>;
}
